<component
        :is="componentName"
        v-bind="vBind"
        v-model:value="currentValue"
/>
